// extracted by mini-css-extract-plugin
module.exports = {"images":"styles_images__60pua","pulse":"styles_pulse__ssXO5","jump":"styles_jump__MtXbi"};